import { render, staticRenderFns } from "./edit-feedback.vue?vue&type=template&id=57b05bec&scoped=true&"
import script from "./edit-feedback.vue?vue&type=script&lang=js&"
export * from "./edit-feedback.vue?vue&type=script&lang=js&"
import style0 from "./edit-feedback.vue?vue&type=style&index=0&id=57b05bec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b05bec",
  null
  
)

export default component.exports